export {
  CustomerReviews as default,
  getStaticProps,
} from '@cinch-nx/feature-customer-reviews'
